
import { defineComponent } from 'vue'
export default defineComponent({
  name: "TPButton",
  props: {
    type: {
      type: String,
      default: "default",
    },
    size: String,
    icon: {
      type: String,
      default: "",
    },
    nativeType: {
      type: String,
      default: "button",
    },
    loading: Boolean,
    disabled: Boolean,
    plain: Boolean,
    autofocus: Boolean,
    round: Boolean,
    circle: Boolean,
  },
  methods: {
    goToGame() {
      this.$store.dispatch('setGameStatus', true)

      //@ts-ignore
      if (window.ta) {
        //@ts-ignore
        ta('specials.2048.startGame', 1, { 
          gameTitle: this.$store.getters.target.title || 'empty',
          gameStartSource: 'menu'
        });
      }

      this.$router.push('/game')
    },
  }
})
